import React from 'react';
import { BeforeAfterAndBonuses, GuaranteeAndCost, PainAndTransformation, ProductOverview, SocialAndFAQ, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { FinalCTA, Pricing, Upsell } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2mmlv773am95u">
      <MetaPixel data-id="element-1" data-mp="31c9uk2rwyxqx" />
      <TopBar data-id="element-2" data-mp="31ctf7r8y808n" />
      <main data-id="element-3" data-mp="2wk09b01quluz">
        <Hero data-id="element-4" data-mp="2wk9y4kb1ymz3" />
        <Testimonials data-id="element-5" data-mp="2wjqg73lejyl2" />
        <Pricing data-id="element-6" data-mp="2wiferaffj2x4" />
        <PainAndTransformation data-id="element-7" data-mp="2whx9joashed2" />
        <ProductOverview data-id="element-8" data-mp="28u5zkrcq1dey" />
        <BeforeAfterAndBonuses data-id="element-9" data-mp="28te21azkd5m1" />
        <Upsell data-id="element-10" data-mp="28sl5f2ubjwhm" />
        <SocialAndFAQ data-id="element-11" data-mp="28s2ztflro5x1" />
        <GuaranteeAndCost data-id="element-12" data-mp="23vuo6c6s2uum" />
        <FinalCTA data-id="element-13" data-mp="23u9qidp62vsj" />
      </main>
      <Footer data-id="element-14" data-mp="23t8i6gzjcnei" />
      <FloatingElements data-id="element-15" data-mp="23ti5fwt74ggi" />
      <noscript data-id="element-16" data-mp="3ikh98cxzsz0k">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-17" data-mp="3iiwfgpji5k3r" />
      </noscript>
    </div>;
}